import React from "react";
import styled from "styled-components";
import { CheckCircle } from "lucide-react";

const WhyChooseCS = () => {
  const benefits = [
    {
      title: "Built for All Churches",
      description:
        "Whether you're a small rural church or a large urban ministry, CS scales with your needs without overwhelming you.",
    },
    {
      title: "Feature-Rich Yet Simple",
      description:
        "From member management and giving to full accounting and communication tools, enjoy powerful features in one intuitive dashboard.",
    },
    {
      title: "Affordable & Transparent Pricing",
      description:
        "No hidden fees. Just straightforward plans based on your church size — with fair pricing and room to grow.",
    },
    {
      title: "Fast Adoption & Minimal Training",
      description:
        "Designed for ease of use so your leaders and volunteers can get started quickly — no IT degree required.",
    },
 
    {
      title: "Trusted by Real Churches",
      description:
        "Backed by real success stories from churches like yours. Built by a team that understands ministry challenges.",
    },
    {
      title: "Comprehensive Reports",
      description:
        "No need to hire worry about hiring expensive accounts as CS takes charge of your church's accounting responsibility all standard financial reports",
    },
      {
      title: "Its Secure",
      description:
        "Your data is encrypted and mantained on secure server. You can focus on your ministry as CS takes administrative tasks for you.",
    },
     {
      title: "We value your online presence",
      description:
        "Every plan involves a free professional website to connect  your church to its community. You can still link it to your custom domain name",
    },
    
    
  ];

  return (
    <Wrapper>
      <div className="container">
        <SectionTitle>Why Choose <span style={{ color: "orange" }}>CS</span>?</SectionTitle>
        <Description>
          Everything your church needs in one affordable, powerful, and ministry-friendly solution.
        </Description>
        <Grid>
          {benefits.map((item, index) => (
            <Card key={index}>
              <IconWrapper>
                <CheckCircle color="#f97316" size={32} />
              </IconWrapper>
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </Card>
          ))}
        </Grid>
      </div>
    </Wrapper>
  );
};

export default WhyChooseCS;

// Styled Components
const Wrapper = styled.section`
  padding: 80px 0;
  background-color: #f9fafb;
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: 800;
  text-align: center;
  margin-bottom: 10px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #555;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 40px auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 16px;
  padding: 30px 25px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-5px);
  }

  h4 {
    margin: 10px 0 10px 0;
    font-size: 20px;
    font-weight: 700;
  }

  p {
    font-size: 14px;
    color: #555;
    line-height: 1.5;
  }
`;

const IconWrapper = styled.div`
  margin-bottom: 10px;
`;

